import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { Language } from '../../types/LabelsResponse';

@Component({
  tag: 'cmm-languages-list',
  styleUrl: 'cmm-languages-list.scss',
  shadow: false,
})
export class LanguagesList implements ComponentInterface {
  @Prop() handleChangeLanguage: (event: MouseEvent) => void;
  @Prop() languages: Language[] = null;
  @Prop() languageSelected: string;

  private hasLanguageAvailables(): boolean {
    return this.languages?.length && this.languages?.length > 1;
  }

  private getLanguageLabel(language: Language): string {
    return (language?.label || language?.code)?.toLocaleUpperCase();
  }

  private activedLanguage(language: Language): boolean {
    return this.languageSelected?.toLocaleUpperCase() === this.getLanguageLabel(language);
  }

  public render(): JSX.Element {
    return (
      <Host>
        {this.hasLanguageAvailables() && (
          <wb7-button-group class="cmm-languages-list">
            {this.languages.map((language: Language) => (
              <wb7-button-group-item
                key={language?.code}
                variant="tertiary"
                size="s"
                class={`cmm-languages-list__item ${
                  this.activedLanguage(language)
                    ? 'cmm-languages-list__item--actived'
                    : 'cmm-languages-list__item--non-actived'
                }`}
                data-language={language?.code}
                data-test="handle-change-language"
                onClick={(event: MouseEvent): void => this.handleChangeLanguage(event)}
              >
                {this.getLanguageLabel(language)}
              </wb7-button-group-item>
            ))}
          </wb7-button-group>
        )}
      </Host>
    );
  }
}
